"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const authProvider_1 = require("@/components/authProvider/authProvider");
const react_router_dom_1 = require("react-router-dom");
const Section_1 = require("@/components/Section");
const Chip_1 = require("@/components/Chip");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
const formatDate_1 = require("@/utils/formatDate");
const stakesSpecific_1 = require("../stakesSpecific/stakesSpecific");
const VoteForProposal_1 = __importDefault(require("./Modals/VoteForProposal"));
const VotesBar_1 = __importDefault(require("@/components/VotesBar"));
const ThumbsIcons_1 = require("./ThumbsIcons");
const styledComponents_1 = require("@/components/styledComponents");
const format_1 = require("@/utils/format");
const commands = {
    SetXDRRatio: "Set XDR Ratio to ",
    Motion: "Motion",
    SetGovMode: "Change Governance Mode",
    CanisterOversight: "Canister Oversight",
    SendSysFunds: "Send System Funds"
};
const topics = {
    SetXDRRatio: "XDR Ratio",
    Motion: "Motion",
    SetGovMode: "Change Governance Mode",
    CanisterOversight: "Canister Oversight",
    SendSysFunds: "Send System Funds"
};
const statuses = {
    Passed: "Passed",
    Open: "Open",
    NoQuorum: "No Quorum"
};
const cells = [
    { id: "id", label: "Stake ID" },
    { id: "date", label: "Date/Time" },
    { id: "vote", label: "Vote" },
];
const replaceText = {
    "Burn transaction": "Proposal to transfer tokens to burning account for ORIGYN Certificates collections created before automated token burning implementation."
};
function calculatePercentage(value1, value2) {
    const total = value1 + value2;
    if (total === 0n) {
        return [0, 0];
    }
    const percentage1 = Number(value1 / total) * 100;
    const percentage2 = Number(value2 / total) * 100;
    return [percentage1, percentage2];
}
const ProposalsSpecific = () => {
    const { principal, loggedIn, governanceActor } = (0, react_1.useContext)(authProvider_1.AuthContext);
    const params = (0, react_router_dom_1.useParams)();
    const { id } = (0, react_router_dom_1.useParams)();
    const [proposal, setProposal] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [isVotingOpened, setIsVotingOpened] = (0, react_1.useState)(false);
    const [myVotes, setMyVotes] = (0, react_1.useState)([0n, 0n]);
    const [myVotableStakes, setMyVotableStakes] = (0, react_1.useState)([]);
    const [myVotableVestedStakes, setMyVotableVestedStakes] = (0, react_1.useState)([]);
    const [myVotedStakes, setMyVotedStakes] = (0, react_1.useState)([]);
    const [proposalStatus, setProposalStatus] = (0, react_1.useState)("Open");
    const getProposalAndStakes = async () => {
        const p = await governanceActor.get_proposal(BigInt(id));
        const pItem = p[0];
        const exp = p[0].expires > BigInt(new Date().getTime() * 10 ** 6);
        let proposalStatus = exp ? "Open" : "Voting Ended";
        console.log(proposalStatus);
        if ((!p[0].result || p[0].result.length === 0) && exp) {
            proposalStatus = "Open";
            console.log(proposalStatus);
            const predict = await governanceActor.predict_vote(BigInt(id));
            console.log(predict, p);
            pItem.for_votes = predict.for_votes;
            pItem.against_votes = predict.against_votes;
        }
        if (!p[0].result || p[0].result.length > 0) {
            try {
                let key = Object.keys(p[0].result[0])[0];
                switch (key) {
                    case 'Passed':
                        proposalStatus = "Executed";
                        break;
                    case 'Failed':
                        proposalStatus = "Failed";
                        break;
                    case 'NoQuorum':
                        proposalStatus = "NoQuorum";
                        break;
                }
            }
            catch {
                console.error("Parsing Result Key Error!", p[0].result[0]);
            }
        }
        // get_staked_tokens_by_principal
        if (loggedIn) {
            const balance = await governanceActor.get_balances();
            const neurons = balance.staked;
            const votableStakes = neurons.filter((val) => {
                return !val[1].votes.find((v) => v[0] === BigInt(id));
            });
            const votedStakes = neurons.filter((val) => {
                return val[1].votes.find((v) => v[0] === BigInt(id));
            });
            setMyVotableStakes(votableStakes);
            setMyVotedStakes(votedStakes);
            const neuronsV = balance.vesting;
            const votableVestedStakes = neuronsV.filter((val) => {
                return !val[1].votes.find((v) => v[0] === BigInt(id));
            });
            setMyVotableVestedStakes(votableVestedStakes);
            const votes = neurons.reduce((sum, val) => {
                const vote = val[1].votes.find((v) => v[0] === BigInt(id));
                if (vote && vote[1] === true) {
                    return [sum[0] + val[1].quantity, sum[1]];
                }
                return [sum[0], sum[1] + val[1].quantity];
            }, [0n, 0n]);
            setMyVotes(votes);
            if (!exp && !p[0].result[0]) {
                try {
                    const finRes = await governanceActor.finalize_vote(BigInt(id));
                }
                catch (e) {
                    console.error("finalize ", e);
                }
            }
        }
        setProposal(p[0]);
        // setProposalStatus( exp? "Open" : "Executed");
        setProposalStatus(proposalStatus);
        setIsLoading(false);
    };
    (0, react_1.useEffect)(() => {
        getProposalAndStakes();
    }, [principal]);
    console.log(proposal);
    return (react_1.default.createElement(origyn_art_ui_1.Container, { padding: '48px', mdPadding: '24' }, proposal ? (react_1.default.createElement(Section_1.Section, null,
        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 24 },
            react_1.default.createElement("h2", null, commands[Object.keys(proposal?.command_type)[0]]),
            react_1.default.createElement(stakesSpecific_1.CustomGrid, null,
                react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 24 },
                    react_1.default.createElement(origyn_art_ui_1.Card, { padding: "24px", bgColor: "NAVIGATION_BACKGROUND" },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: 'column', gap: 16 },
                            react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, align: "center", justify: 'space-between' },
                                react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 24, align: "center" },
                                    react_1.default.createElement(Chip_1.Chip, { bgColor: "#D9F3C7", color: "#01630A" },
                                        react_1.default.createElement("b", null, proposal.result && proposal.result[0] ? statuses[Object.keys(proposal.result[0])[0]] : "Open")),
                                    react_1.default.createElement("p", null,
                                        "Proposal ID: ",
                                        proposal.id.toString())),
                                react_1.default.createElement("p", null,
                                    "Posted ",
                                    (0, formatDate_1.formatTime)(proposal.id))),
                            react_1.default.createElement(origyn_art_ui_1.HR, null),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, flexFlow: 'column', gap: 4 },
                                react_1.default.createElement("h6", null, "More Info:"),
                                react_1.default.createElement("p", null, replaceText[decodeURI(proposal.command_type[Object.keys(proposal.command_type)[0]].text)] || decodeURI(proposal.command_type[Object.keys(proposal.command_type)[0]].text || "Adittional data for Proposals should be added.")),
                                Object.keys(proposal.command_type)[0] === "SendSysFunds" && (react_1.default.createElement("p", null,
                                    react_1.default.createElement("b", null, "Amount:"),
                                    "  ",
                                    (0, format_1.formatNatAmount)(proposal?.command_type?.SendSysFunds?.request?.ICRC1?.amount),
                                    " (",
                                    proposal?.command_type?.SendSysFunds?.request?.ICRC1?.amount.toString(),
                                    " in Nat)"))),
                            react_1.default.createElement(origyn_art_ui_1.HR, null),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { gap: 8, align: "center" },
                                react_1.default.createElement("p", null,
                                    react_1.default.createElement("b", null, "Topic:")),
                                react_1.default.createElement(Chip_1.Chip, { bgColor: "#EDC7F2", color: "#43154A" },
                                    react_1.default.createElement("b", null, topics[Object.keys(proposal.command_type)[0]]))))),
                    loggedIn && (react_1.default.createElement(origyn_art_ui_1.Card, { padding: "24px", bgColor: "NAVIGATION_BACKGROUND" },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 24, fullWidth: true },
                            react_1.default.createElement("h3", null, "My Voting History"),
                            myVotedStakes.length ? (react_1.default.createElement(styledComponents_1.TableWrap, null,
                                react_1.default.createElement(origyn_art_ui_1.CustomTable, { cells: cells, rows: myVotedStakes.map((stake) => ({ id: stake[0].toString(), date: (0, formatDate_1.formatTime)(stake[1].createdDate), vote: stake[1].votes.find((v) => v[0] === BigInt(id))[1] ? "Adopt" : "Reject" })) }))) : (react_1.default.createElement("h6", null, "You have no votes on this proposal")))))),
                react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 24 },
                    react_1.default.createElement(origyn_art_ui_1.Card, { padding: "24px", bgColor: "NAVIGATION_BACKGROUND" },
                        react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: 'column', gap: 24, fullWidth: true },
                            loggedIn && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("h6", null, "Actions"),
                                react_1.default.createElement(origyn_art_ui_1.Button, { btnType: "filled", onClick: () => setIsVotingOpened(true) }, "Vote"),
                                react_1.default.createElement(origyn_art_ui_1.HR, null))),
                            react_1.default.createElement("h6", null, "Proposal Status"),
                            react_1.default.createElement("h4", null,
                                (0, format_1.formatNatAmount)(proposal.for_votes + proposal.against_votes).split(".")[0],
                                " Votes"),
                            react_1.default.createElement(VotesBar_1.default, { pgcolor: "#5EAC31", bgcolor: "#DD1422", margin: "4px 0 10px 0", progress: proposal.for_votes === proposal.against_votes
                                    ? 50
                                    : Math.floor((Number(proposal.for_votes / 100000000n) /
                                        Number((proposal.for_votes + proposal.against_votes) /
                                            100000000n)) *
                                        100), height: 4 }),
                            react_1.default.createElement(origyn_art_ui_1.Flex, { fullWidth: true, justify: "space-between" },
                                react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", gap: 5 },
                                    react_1.default.createElement(ThumbsIcons_1.ThumbUp, null),
                                    react_1.default.createElement("div", null,
                                        react_1.default.createElement("h3", null,
                                            calculatePercentage(proposal.for_votes, proposal.against_votes)[0].toString(),
                                            "%"),
                                        react_1.default.createElement("p", null, "Adopt"))),
                                react_1.default.createElement(origyn_art_ui_1.Flex, { flexFlow: "column", align: "flex-end", gap: 5 },
                                    react_1.default.createElement(ThumbsIcons_1.ThumbDown, null),
                                    react_1.default.createElement("div", { style: { textAlign: "right" } },
                                        react_1.default.createElement("h3", null,
                                            calculatePercentage(proposal.for_votes, proposal.against_votes)[1].toString(),
                                            "%"),
                                        react_1.default.createElement("p", null, "Reject"))))))))),
        react_1.default.createElement(VoteForProposal_1.default, { isOpened: isVotingOpened, onClose: () => setIsVotingOpened(false), proposal: proposal, onVoteEnd: getProposalAndStakes }))) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.default = ProposalsSpecific;
